<template>
	<vTable :columns="columns" :data="data" border></vTable>
</template>
<script>
export default {
    props:['data'],
	computed: {
        operateStatus(){
            return {
                100:"创建",
                200:"更新",
                210:"提交",
                220:"发运",
                300:"删除", 
                400:"取消",
                500:"审核通过",
                600:"驳回",
                720:"确认",
                800:"完成",
                830:"生成箱标",
                900:"预约",
                910:"添加备注",
                930:"推送仓库",
                935:"取消推送仓库",
                940:"执行单推送仓库",
                945:"完成推送仓库",
                1010:"调拨入库执行单回传boss",
               /*  940:"仓库返回异常", */
                950:"仓库返回异常",
                960:"仓库返回异常",
                970:"仓库返回异常",
            };
        },
		columns() {
			return [{
				title: '操作人',
				key: 'createdName',
			}, {
				title: '操作类型',
				key: 'operateType',
				render: (h, { row }) => {
					return this.operateStatus[row.operateType];
				},
			}, {
				title: '操作原因 ',
				key: 'remark',
			}, {
				title: '操作时间 ',
				key: 'createdAt',
			}];
		}
	}
}
</script>
